import { Component } from 'vue-property-decorator';
import AbstractDisplayField from '../abstract-display-field/abstract-display-field';
import { mixins } from 'vue-class-component';
import Avatar from 'vue-avatar';

@Component({
  name: 'bpc-display-field-avatar',
  components: {
    Avatar,
  },
})
export default class DisplayFieldAvatar extends mixins(AbstractDisplayField) {
  get width() {
    return this.fieldConfig.width || 44;
  }
  get height() {
    return this.fieldConfig.height || 44;
  }

  currentImgField = 'defaultConversionUrl';
  imgFail = false;

  onImgError() {
    if (this.currentImgField === 'url') {
      this.imgFail = true;
    }
    if (this.currentImgField === 'defaultConversionUrl') {
      this.currentImgField = 'url';
    }
  }

  get avatar() {
    if (this.imgFail) {
      return null;
    }
    if (this.value instanceof Array) {
      return this.value[0][this.currentImgField];
    }
    if (this.value instanceof Object) {
      return this.value[this.currentImgField];
    }
    return null;
  }
}
